import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    carePlans: [],
  },
  getters: {
    carePlans(state) {
      return state.carePlans;
    }
  },
  actions: {
    /* CAREPLANS by HeartBeatFam*/
    addCarePlan({ commit, state }, {rootPathDoc, plan}) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(rootPathDoc);
        plansRef
            .get()
            .then(doc => {
              if (doc.exists && doc.data() && doc.data().plans) {
                plansRef.update({
                  plans: [...doc.data().plans, plan],
                  _updated_at: new Date()
                });
              } else {
                plansRef.set({
                  _created_at: new Date(),
                  plans: [plan]
                });
              }
              res(true);
            })
            .catch(err => {
              console.log("error in saving care plan:", err);
              rej(err);
            });
      });
    },
    updateCarePlan({ commit, state }, {rootPathDoc, id, plan }) {
      debugger;
      console.log("p=>",id);
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(rootPathDoc);
        return plansRef.get().then(doc => {
          let data = { ...doc.data() };

          data.plans.forEach(aPlan => {
            if (aPlan.id == id) {
              aPlan._updated_at = new Date();
              aPlan.plan = plan;
            }
          });
          return plansRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    getListCarePlans({ commit, state }) {
      debugger
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _plansRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("lists")
            .doc(`__careplans`);

        _plansRef
            .get()
            .then(function(doc) {
              if (
                  doc.exists &&
                  doc.data().plans &&
                  doc.data().plans.length
              ) {
                let activePlans = doc
                    .data()
                    .plans.filter(e => e._deleted_at == null);
                commit("SET_CARE_PLANS", activePlans);
                res(doc.data().plans);
              } else {
                res([]);
              }
            })
            .catch(function(error) {
              console.error("Error in getting blogs: ", error);
              rej(error);
            });
      });
    },
    updateCarePlanStatus({ commit, state }, {plan, version, status}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(
            `users/${state.user.uid}/lists/__careplans`
        );
        return plansRef.get().then(doc => {
          let data = { ...doc.data() };

          //Updating
          if (data && data.plans) {
            data.plans.forEach(aPlan => {
              if (aPlan.id == plan.id) {

                if (version) {
                  if (!aPlan.versions || !Array.isArray(aPlan.versions)) aPlan.versions = [];
                  aPlan.versions.push({
                    _created_at: new Date(),
                    version
                  })
                }

                aPlan.status = status;
                aPlan._submitted_at = new Date();
              }
            });
          }
          return plansRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Care Plan Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    deleteCarePlan({ commit, state }, id) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let sessions = [];
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionsRef.get().then(doc => {
          let data = { ...doc.data() };
          data.sessions.forEach(aSession => {
            if (aSession.id === id) {
              aSession._deleted_at = new Date();
            }
          });
          return sessionsRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Sessions Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },

    /* SESSIONS by HeartBeatFam */
    addSession({ commit, state }, {rootPathDoc, session}) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.doc(rootPathDoc);

        sessionsRef
            .get()
            .then(doc => {
              if (doc.exists) {
                sessionsRef.update({
                  sessions: [...doc.data().sessions, session],
                  _updated_at: new Date()
                });
              } else {
                sessionsRef.set({
                  _created_at: new Date(),
                  sessions: [session]
                });
              }
              res(true);
            })
            .catch(err => {
              console.log("error in saving user session:", err);
              rej(err);
            });
      });
    },
    getListSessionsArch({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _userSessionsRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("lists")
            .doc("__sessions");

        _userSessionsRef
            .get()
            .then(function(doc) {
              // querySnapshot.forEach((doc) => {
              if (
                  doc.exists &&
                  doc.data().sessions &&
                  doc.data().sessions.length
              ) {
                commit("SET_SESSIONS", [...doc.data().sessions]);
                res(doc.data().sessions);
              } else {
                res(true);
              }
              // });
            })
            .catch(function(error) {
              console.error("Error get user sessions: ", error);
              rej(error);
            });
      });
    },
    getListSessions({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _sessionsRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("lists")
            .doc(`__sessions`);

        _sessionsRef
            .get()
            .then(function(doc) {
              if (
                  doc.exists &&
                  doc.data().sessions &&
                  doc.data().sessions.length
              ) {
                let activeSessions = doc
                    .data()
                    .sessions.filter(e => e._deleted_at == null);
                commit("SET_SESSIONS", activeSessions);
                res(doc.data().sessions);
              } else {
                res([]);
              }
            })
            .catch(function(error) {
              console.error("Error in getting blogs: ", error);
              rej(error);
            });
      });
    },
    updateSessionStatus({ commit, state }, {session, version, status}) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionsRef.get().then(doc => {
          let data = { ...doc.data() };

          //Updating
          if (data && data.sessions) {
            data.sessions.forEach(aSession => {
              if (aSession.id == session.id) {

                if (version) {
                  if (!aSession.versions || !Array.isArray(aSession.versions)) aSession.versions = [];
                  aSession.versions.push({
                    _created_at: new Date(),
                    version
                  })
                }

                aSession.status = status;
                aSession._submitted_at = new Date();
              }
            });
          }
          return sessionsRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Session Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    updateSession({ commit, state }, {rootPathDoc, id, session }) {
      console.log("p=>",id);
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionRef = db.doc(rootPathDoc);
        return sessionRef.get().then(doc => {
          let data = { ...doc.data() };

          data.sessions.forEach(aSession => {
            if (aSession.id == id) {
              aSession._updated_at = new Date();
              aSession.session = session;
            }
          });
          return sessionRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    deleteSession({ commit, state }, id) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let sessions = [];
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionsRef.get().then(doc => {
          let data = { ...doc.data() };
          data.sessions.forEach(aSession => {
            if (aSession.id === id) {
              aSession._deleted_at = new Date();
            }
          });
          return sessionsRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Sessions Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    addSessonVideo({ commit, state }, { id, video }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
            `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack.video = video;
              aTrack._updated_at = new Date();
            }
          });
          return trackRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    updateSessionVideoThumbnail({ commit, state }, { id, thumbnail }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
            `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        let trackVideo = null;
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack._updated_at = new Date();
              aTrack.video._updated_at = new Date();
              aTrack.video._thumb_at = new Date();
              aTrack.video.videoThumb = thumbnail;
              aTrack._updated_at = new Date();
              trackVideo = aTrack.video;
            }
          });
          return trackRef
              .update({
                ...data
              })
              .then(function() {
                let listingTrackRef = db
                    .collection("listings/tracks_guide/items")
                    .doc(id);
                listingTrackRef
                    .get()
                    .then(function(doc) {
                      let track = doc.data();
                      track.doc.video = trackVideo;

                      return listingTrackRef
                          .update(track)
                          .then(function() {
                            console.log("Track Successfully updated!");
                            res(true);
                          })
                          .catch(function(error) {
                            console.error("Error updating Blog: ", error);
                            rej(error);
                          });
                    })
                    .catch(function(error) {
                      console.log("Error getting document:", error);
                      rej(error);
                    });
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },

    /* GENERAL ITEM: Warehouse, */
    addItem({ commit, state }, {rootPathDoc, itemType, itemPayload, ip}) {
  debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const itemsRef = db.doc(rootPathDoc);
        itemPayload.ip = ip;
        itemsRef
            .get()
            .then(doc => {
              if (doc.exists && doc.data() && doc.data()[itemType]) {
                itemsRef.update({
                  [itemType]: [...doc.data()[itemType], itemPayload],
                  _updated_at: new Date()
                });
              } else {
                itemsRef.set({
                  _created_at: new Date(),
                  [itemType]: [itemPayload]
                });
              }
              res(true);
            })
            .catch(err => {
              console.log("error in saving item:", err);
              rej(err);
            });
      });
    },
    updateItem({ commit, state }, {rootPathDoc, id, plan }) {
      debugger;
      console.log("p=>",id);
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(rootPathDoc);
        return plansRef.get().then(doc => {
          let data = { ...doc.data() };

          data.plans.forEach(aPlan => {
            if (aPlan.id == id) {
              aPlan._updated_at = new Date();
              aPlan.plan = plan;
            }
          });
          return plansRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    getListItems({ commit, state }) {
      debugger
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _plansRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("lists")
            .doc(`__careplans`);

        _plansRef
            .get()
            .then(function(doc) {
              if (
                  doc.exists &&
                  doc.data().plans &&
                  doc.data().plans.length
              ) {
                let activePlans = doc
                    .data()
                    .plans.filter(e => e._deleted_at == null);
                commit("SET_CARE_PLANS", activePlans);
                res(doc.data().plans);
              } else {
                res([]);
              }
            })
            .catch(function(error) {
              console.error("Error in getting blogs: ", error);
              rej(error);
            });
      });
    },
    updateItemStatus({ commit, state }, {plan, version, status}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(
            `users/${state.user.uid}/lists/__careplans`
        );
        return plansRef.get().then(doc => {
          let data = { ...doc.data() };

          //Updating
          if (data && data.plans) {
            data.plans.forEach(aPlan => {
              if (aPlan.id == plan.id) {

                if (version) {
                  if (!aPlan.versions || !Array.isArray(aPlan.versions)) aPlan.versions = [];
                  aPlan.versions.push({
                    _created_at: new Date(),
                    version
                  })
                }

                aPlan.status = status;
                aPlan._submitted_at = new Date();
              }
            });
          }
          return plansRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Care Plan Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    deleteItem({ commit, state }, id) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let sessions = [];
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionsRef.get().then(doc => {
          let data = { ...doc.data() };
          data.sessions.forEach(aSession => {
            if (aSession.id === id) {
              aSession._deleted_at = new Date();
            }
          });
          return sessionsRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Sessions Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
  },
  mutations: {

  }
};
